export default __webpack_public_path__ + "static/media/road-hazard-reindeers-shadow.7af3deb9.svg";